// extracted by mini-css-extract-plugin
module.exports = {"ripple":"_819072","wrapper":"_aaf5a5"};